export enum HttpMethodType {
	Delete = 'DELETE',
	Get = 'GET',
	Post = 'POST',
	Patch = 'PATCH',
}